import { createCart, getCart, mergeMaskedCart } from '@/services/cart';
import useCart from '@/store/cart.store';
import { setCookie, getCookie } from 'cookies-next';

export const mergeGuestCart = async (session) => {
  const quote = getCookie('quote');
  const mage = session?.mage || getCookie('mage');
  if (quote?.match(/^\d+$/)) return;
  if (
    quote?.match(/^\d+$/) === null &&
    session &&
    quote &&
    quote != 'undefined'
  ) {
    const { store_id, id } = session?.user || {};
    const res = await mergeMaskedCart(mage, quote, store_id, id);

    if (res.error === null && res.data?.data) {
      await loginCartHandler(session);
    }
    return;
  }

  if (!quote?.match(/^\d+$/) && session) {
    await loginCartHandler(session);
  }
};

export const loginCartHandler = async (session) => {
  const quote = getCookie('quote');
  const mage = session?.mage || getCookie('mage');
  const setCart = useCart.getState().setCart;

  const { error, data } = await createCart({ mage });

  if (!error) {
    setCookie('quote', data?.cart_id);
  }
  const cartRes = await getCart({ mage, quote });
  setCart(cartRes?.data?.data);
  if (cartRes?.data?.quoteId !== quote) {
    setCookie('quote', cartRes?.data?.quoteId);
  }
};
